/* eslint-disable no-sequences */
/**
 * @deprecated This file has been refactored into modular utilities in src/utils/
 * Please import from specific modules:
 * - Format utilities: import { slugify, cdnImage, meterDisplay } from "../utils/format"
 * - Collection utilities: import { groupBy, findCommonElements, chunk } from "../utils/collection"
 * - Safe access utilities: import { getSafe, getSafeArrayElement, validateEmail } from "../utils/safe"
 * - Geographic utilities: import { getCardinal } from "../utils/geo"
 * - Date utilities: import { diffInDays } from "../utils/date"
 * - API utilities: import { feedBi } from "../utils/api"
 * - Locale utilities: import { supportedLocal, citySlugToName } from "../utils/locale"
 * - Or use barrel import: import { functionName } from "../utils"
 *
 * @param {*} evt
 * @param {*} cityName
 */

import {
  API_STATS_LIVE,
  CDN_ENDPOINT,
  NO_IMAGE,
  RESIZE_URL,
} from "./constants";

export function validateEmail(email) {
  const re =
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function getSafe(fn, defaultVal) {
  try {
    return fn();
  } catch (e) {
    return defaultVal;
  }
}

export function getSafeArrayElement(array, index, fallback = null) {
  try {
    return array && Array.isArray(array) && array.length > index && index >= 0
      ? array[index]
      : fallback;
  } catch (e) {
    return fallback;
  }
}

export function citySlugToName(slug, cities, local) {
  return (
    getSafe(() => cities.filter((c) => c.slug === slug)[0].title[local]) || slug
  );
}

export function cdnImage(url, width = "w_800", extension = "f_jpg") {
  if (!url) return NO_IMAGE;
  const urlOne = url.replace(
    "https://productionvisittanger.s3.eu-central-1.amazonaws.com/uploads",
    CDN_ENDPOINT
  );

  return urlOne.replace(
    CDN_ENDPOINT,
    "https://cdn.visitbenimellal.com/fetch/c_scale,fl_progressive,q_auto," +
      width +
      "/" +
      extension +
      "/" +
      CDN_ENDPOINT
  );
}

export const constructResponsiveImgUrl = (src, width, quality) => {
  const url = new URL(RESIZE_URL);
  url.searchParams.set("url", src);
  url.searchParams.set("width", width);
  url.searchParams.set("type", "webp");
  url.searchParams.set("quality", quality ?? 75);
  url.searchParams.set("stripmeta", "true"); // Remove EXIF data for smaller file size
  url.searchParams.set("compression", "9"); // Maximum compression
  return url.toString();
};

/**
 * https://stackoverflow.com/questions/40774697/how-to-group-an-array-of-objects-by-key
 * const cars = [{ make: 'audi', model: 'r8', year: '2012' }, { make: 'audi', model: 'rs5', year: '2013' }, { make: 'ford', model: 'mustang', year: '2012' }, { make: 'ford', model: 'fusion', year: '2015' }, { make: 'kia', model: 'optima', year: '2012' }];
 * const result = groupBy(cars, (c) => c.make);
 *
 */

export function groupBy(xs, f) {
  // eslint-disable-next-line
  return xs.reduce(
    (r, v, i, a, k = f(v)) => (
      (r[k.toLowerCase()] || (r[k.toLowerCase()] = [])).push(v), r
    ),
    {}
  );
}

export function findCommonElements(arr1, arr2) {
  try {
    return arr1.some((item) => arr2.includes(item));
  } catch (e) {
    return false;
  }
}
export function meterDisplay(m) {
  const realLifeDistanceApprox = m * 1.3;
  if (realLifeDistanceApprox < 1000) {
    return realLifeDistanceApprox.toFixed(0) + " m";
  }

  if (realLifeDistanceApprox >= 1000) {
    return (realLifeDistanceApprox / 1000).toFixed(2) + " km";
  }
}
export function slugify(text, local) {
  if (local === "ar" && text) return text.replace(" ", "-");
  try {
    return text
      .toString()
      .toLowerCase()
      .replace(new RegExp("[àáâãäå]", "g"), "a") // handling diactritics
      .replace(new RegExp("æ", "g"), "ae")
      .replace(new RegExp("ç", "g"), "c")
      .replace(new RegExp("[èéêë]", "g"), "e")
      .replace(new RegExp("[ìíîï]", "g"), "i")
      .replace(new RegExp("ñ", "g"), "n")
      .replace(new RegExp("[òóôõö]", "g"), "o")
      .replace(new RegExp("œ", "g"), "oe")
      .replace(new RegExp("[ùúûü]", "g"), "u")
      .replace(new RegExp("[ýÿ]", "g"), "y")
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w]+/g, "") // Remove all non-word chars
      .replace(/\+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  } catch (e) {
    return "default";
  }
}
// calculte nbr of days btw two dates
export function diffInDays(dateOne, dateTwo) {
  if (!dateOne || !dateTwo) return 1;
  // eslint-disable-next-line
  {
    /** THIS IS TEMPORARY FIX */
    /** PROBLEM: Calendar format is dd/mm/yyyy */
    /** New Date require a yyyy-mm-dd */
  }
  const timeOne = new Date(dateOne.split("/").reverse().join("-")).getTime();
  const timeTwo = new Date(dateTwo.split("/").reverse().join("-")).getTime();
  const diff = Math.round((timeTwo - timeOne) / (1000 * 3600 * 24));
  if (diff > 0) {
    return diff;
  }
  return 1;
}
export function feedBi(data) {
  fetch(API_STATS_LIVE, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(function (response) {
      return response.json();
    })
    .catch(function (e) {
      console.log("__BI__SYNC__ERROR");
    });
}

//implement this
export function supportedLocal() {
  //const current = getLang()

  //if (SUPPORTED_LOCALS.indexOf(current) > -1) {
  //  return current
  //}
  return "en";
}

export function getCardinal(angle, isInstruction = false) {
  if (typeof angle === "string") angle = parseInt(angle);
  if (angle < 0 || angle > 360 || typeof angle === "undefined") return null;

  switch (Math.round(angle / 22.5)) {
    case 1:
      return isInstruction ? "keep_ahead" : "NNE";
    case 2:
      return isInstruction ? "keep_ahead" : "NE";
    case 3:
      return isInstruction ? "right" : "ENE";
    case 4:
      return isInstruction ? "right" : "E";
    case 5:
      return isInstruction ? "right" : "ESE";
    case 6:
      return isInstruction ? "u_turn" : "SE";
    case 7:
      return isInstruction ? "u_turn" : "SSE";
    case 8:
      return isInstruction ? "u_turn" : "S";
    case 9:
      return isInstruction ? "u_turn" : "SSW";
    case 10:
      return isInstruction ? "u_turn" : "SW";
    case 11:
      return isInstruction ? "left" : "WSW";
    case 12:
      return isInstruction ? "left" : "W";
    case 13:
      return isInstruction ? "left" : "WNW";
    case 14:
      return isInstruction ? "left" : "NW";
    case 15:
      return isInstruction ? "keep_ahead" : "NNW";
    default:
      return isInstruction ? "keep_ahead" : "N";
  }
}

/**
 * Split an array into chunks of specified size
 * @param {Array} array - The array to chunk
 * @param {number} size - The size of each chunk
 * @returns {Array} Array of chunks
 */
export function chunk(array, size) {
  if (!Array.isArray(array) || size <= 0) return [];
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}

// Fisher-Yates shuffle algorithm
export const shuffleArray = (array) => {
  if (!array || array.length === 0) return [];

  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
